<template>
  <app-layout title="Product">
    <PageTitle :headerTitle="title"> </PageTitle>

    <div class="py-4">
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div class="overflow-hidden sm:rounded-lg">
          <div class="text-center">
            <h5>Select a product to edit, or create a new product.</h5>
          </div>

          <div class="grid grid-cols-10 break-words gap-2 mt-2">
            <div class="bg-white rounded-md card-style">
              <jet-responsive-nav-link @click="goToCreate">
                <i
                  class="fas fa-plus fa-2x icon-center mt-2"
                  aria-hidden="true"
                ></i>
                <br />

                <div class="text-center leading-4">Add Product</div>
              </jet-responsive-nav-link>
            </div>


               <div class="bg-white rounded-md card-style" v-on:click="showImportPopup">
              <div class="pt-2 hover:cursor-pointer">
                <i
                  class="fas fa-file-import fa-2x icon-center mt-2"
                  aria-hidden="true"
                ></i>
                <br />

                <div class="text-center leading-4">Import</div>
              </div>

             
            </div>
            



            <div class="bg-white rounded-md card-style" v-for="mod of products">
              <jet-responsive-nav-link
                :href="route(moduleRoute + '.show', mod.id)"
              >
                <i
                  class="fas fa-cubes fa-2x icon-center mt-2"
                  aria-hidden="true"
                ></i>
                <br />
                <div class="text-center leading-4">{{ mod.name }}</div>
              </jet-responsive-nav-link>
            </div>

             <!-- Import Popup -->
             <DxPopup
                v-model:visible="popupVisible"
                :width="460"
                :height="440"
                :show-title="true"
                :title="Import"
                :drag-enabled="false"
                :close-on-outside-click="true"                
              >
                 <template  #content>
                  
                  <div class="popup-property-details">                    
                          
                        <div v-for="item in avl_modules" class="grid grid-cols-2 border rounded-lg mt-1 p-2">
                            <span class="text-left text-black">{{item}}</span>
                            <div class="text-right text-black">
                              <input type="checkbox" id="" :value="item" v-model="ImportModules" >
                            </div>
                        </div>
                                          
                        <button @click="importModule" class="absolute bottom-2 right-2 btn btn-success">Import</button>
                  </div>
                </template>
              </DxPopup>




          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<style>
.card-style {
  min-height: 70px;
}

.icon-center {
  text-align: center;
  width: 100%;
}
</style>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import DxPopup from "devextreme-vue/popup";
import DxButton from "devextreme-vue/button";
import { DxPosition, DxToolbarItem } from "devextreme-vue/popup";
import { DxToast } from "devextreme-vue/toast";

import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink.vue";
let collapsed = false;

export default {
  props: {
    products: Array,
    moduleRoute: String,
    avl_modules:Array

  },
  components: {
    AppLayout,
    PageTitle,
    JetResponsiveNavLink,
    DxPopup,
    DxButton,
    DxPosition,
    DxToolbarItem,
    DxToast
  },

  data() {
    return {
      title: "Product",
      popupVisible: false,
      ImportModules: [],
      isVisible: false,


    };
  },
  methods: {
    sayHelloWorld() {
      alert("Hello world!");
    },
    goToCreate() {
      var route = "product/create";
      console.log(this.moduleRoute);
      this.$inertia.get(route);
    },
    goToShow() {
      this.$inertia.get(this.moduleRoute + "/show");
    },
    showImportPopup() {
      this.popupVisible = true;
    },
    showImportPopup(){
            this.popupVisible = true;
    },
    
 importModule()
    {
      this.$inertia.post(route(this.moduleRoute+".import", {"list":this.ImportModules}), {
        onSuccess: this.showToast("Successfully Export", "success"),
      });
      this.popupVisible = false;
      this.ImportModules = [];
    },

     showToast(message, type) {
      this.isVisible = true;
      this.message = message;
      this.type = type;
    }

  },
  mounted() {
   
  },
};
</script>
